module.exports = __webpack_public_path__ + "img/admin-feature-responsive.4a81846b.png";